import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark } from "lucide-react";
import api from "@/lib/api";
import { ListingCard } from "@/components/cards";
import { Loader, SectionHeader, EmptyState, PrimaryButton } from "@/components/ui-bits";

export default function Saved() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/saved").then((r) => setItems(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
      <SectionHeader eyebrow="Saved" title="Your favorites" subtitle="Marketplace listings you've saved for later." />
      {!items ? <Loader /> : items.length ? (
        <div className="grid gap-5 grid-cols-2 lg:grid-cols-4" data-testid="saved-grid">{items.map((l) => <ListingCard key={l.id} l={l} />)}</div>
      ) : (
        <EmptyState icon={Bookmark} title="Nothing saved yet" hint="Tap the bookmark on any listing to save it here."
          action={<PrimaryButton as={Link} to="/marketplace">Browse marketplace</PrimaryButton>} />
      )}
    </div>
  );
}
